<div class="modal-header">
    <h4 class="modal-title">
        <i data-feather="alert-circle"></i> {{data.title}}
    </h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="form-group">
        <label for="basicInput">Tür</label>
        <input type="text" class="form-control" id="basicInput" placeholder="Tür Adı Gir" [(ngModel)]="kindName" />
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal()">İptal</button>
    <button type="button" class="btn btn-success" (click)="confirm()" [disabled]="!kindName">Kaydet</button>
</div>